import moment from "moment"; //获取日期所在周

function getWeekDays(weekStart) {
  const days = [weekStart];

  for (let i = 1; i < 7; i += 1) {
    days.push(moment(weekStart).add(i, "days").toDate());
  }

  return days;
}

function getWeekRange(date) {
  //用isoWeekday把第一天改为周一，直接用startof('week')第一天是周日
  return {
    from: moment(date).isoWeekday(1).toDate(),
    to: moment(date).endOf("week").isoWeekday(7).toDate()
  };
}

function getWeekRanges(date) {
  //用isoWeekday把第一天改为周一，直接用startof('week')第一天是周日
  return {
    from: moment(date).startOf('isoWeek'),
    to: moment(date).endOf('isoWeek')
  };
}

function getMonthRange(date) {
  return {
    from: moment(date).startOf('month'),
    to: moment(date).endOf("month")
  };
}

function getNowDay() {
  return {
    from: moment().startOf('day'),
    to: moment().endOf('day')
  };
}

const date = {
  init(fmt, date = new Date()) {
    const o = {
      "M+": date.getMonth() + 1,
      "D+": date.getDate(),
      "H+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds(),
      "q+": Math.floor((date.getMonth() + 3) / 3),
      S: date.getMilliseconds()
    };

    if (/(Y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }

    for (const k in o) {
      if (new RegExp("(" + k + ")").test(fmt)) {
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
      }
    }

    return fmt;
  },

  // 仅支持 month、week，其他均返回当前天
  getFirstDay(type, date = new Date()) {
    if (type === "month") {
      return new Date(date.getFullYear(), date.getMonth(), 1);
    } else if (type === "week") {
      return new Date(date.valueOf() - date.getDay() * 1000 * 60 * 60 * 24);
    } else return new Date();
  },

  // 仅支持 month、week，其他均返回当前天
  getLastDay(type, date = new Date()) {
    if (type === "month") {
      const Y = date.getMonth() < 12 ? date.getFullYear() : date.getFullYear() + 1;
      const M = date.getMonth() < 12 ? date.getMonth() + 1 : 1;
      return new Date(Y, M, 1);
    } else if (type === "week") {
      return new Date(date.valueOf() - date.getDay() * 1000 * 60 * 60 * 24);
    } else return new Date();
  },

  _i18n: {
    previousMonth: "上月",
    nextMonth: "下月",
    months: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
    weekdays: ["日", "一", "二", "三", "四", "五", "六"],
    weekdaysShort: ["日", "一", "二", "三", "四", "五", "六"]
  },

  getDate(index, separator) {
    const _separator = separator === '' || separator ? separator : '/'; //获取近几天日期


    const newDate = new Date();
    newDate.setDate(newDate.getDate() + index);
    const month = newDate.getMonth() < 9 ? "0" + (newDate.getMonth() + 1) : newDate.getMonth() + 1;
    const day = newDate.getDate() < 10 ? "0" + newDate.getDate() : newDate.getDate();
    return newDate.getFullYear() + _separator + month + _separator + day;
  },

  getMonthsNum(sMon, eMon) {
    if (eMon.getFullYear() === sMon.getFullYear()) {
      return eMon.getMonth() - sMon.getMonth() + 1;
    } else {
      const sMonsNum = 12 - sMon.getMonth() + 1;
      const eMonsNum = eMon.getMonth();
      const cMonsNum = (eMon.getFullYear() - sMon.getFullYear() - 1) * 12;
      return sMonsNum + cMonsNum + eMonsNum;
    }
  },

  getThisFullWeek(date) {
    return getWeekDays(getWeekRange(date).from);
  },

  getThisMonthLastDay(year, month) {
    const _month = parseInt(month, 10);

    const d = new Date(year, _month, 0);
    return d.getDate();
  },

  //获取多少天前0点的Date对象-用于只选择日期的场景
  getDay(day) {
    const now = new Date();
    const today = now.getTime() - now.getHours() * 60 * 60 * 1000 - now.getMinutes() * 60 * 1000 - now.getSeconds() * 1000 - now.getMilliseconds();
    return new Date(today - day * 24 * 60 * 60 * 1000);
  },

  //兼容datePicker只支持传moment类型
  getMonthRangeMoment(date = new Date()) {
    return getMonthRange(date);
  },

  getWeekRangeMoment(date = new Date()) {
    return getWeekRanges(date);
  },

  getNowDayMoment() {
    return getNowDay();
  }

};
export default date;